import React, { FC, createContext, useState, useEffect } from 'react'
import axios from 'axios'

import {
  BOWIE_SSH_IMAGE_FILENAME,
} from '@shared/constants'

import {
  base64ToUrl,
  bufferToBase64,
  bufferToBinary,
} from '@shared/image'

export interface IBowieImageContext {

  imageUrl: string,
  imageBinary: string,
  imageError: string,

}

export const BowieImageContext = createContext<IBowieImageContext>({
  imageUrl: '',
  imageBinary: '',
  imageError: '',
})

export const BowieImageProvider: FC = ({
  children,
}) => {

  const [ imageUrl, setImageUrl ] = useState('')
  const [ imageBinary, setImageBinary ] = useState('')
  const [ imageError, setImageError ] = useState('')

  useEffect(() => {
    if(imageUrl.length > 0) return
    const doAsync = async () => {
      try {
        const res = await axios({
          method: 'get',
          url: `/bowie/${BOWIE_SSH_IMAGE_FILENAME}`,
          responseType: 'arraybuffer',
        })
        const data = new Uint8Array(res.data)
        setImageBinary(bufferToBinary(data))
        setImageUrl(base64ToUrl(bufferToBase64(data)))
      } catch(e: any) {
        console.error(e)
        setImageError(e.toString())
      }
    }
    doAsync()
  }, [])

  return (
    <BowieImageContext.Provider value={{
      imageUrl,
      imageBinary,
      imageError,
    }}>
      { children }
    </BowieImageContext.Provider>
  )
}

export default BowieImageContext